import { Component, OnInit, Output ,Input, EventEmitter} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators, UntypedFormControl, AbstractControl, FormArray ,ValidatorFn  } from '@angular/forms';
import { SearchtoolboxService } from 'src/app/_services/searchtoolbox.service';
import { Observable, Subject } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CandidateService } from 'src/app/_services/candidate.service';
import { TalentpoolService } from 'src/app/_services/talentpool.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';



@Component({
    selector: 'app-create-candidate-new',
    templateUrl: './create-candidate-new.component.html',
    styleUrls: ['./create-candidate-new.component.scss'],
    standalone: false
})
export class CreateCandidateNewComponent implements OnInit {
  create_candidate : UntypedFormGroup
  autocomplete_company:boolean = true
  companylist: any;
  locationlist: any;
  parentSubject: Subject<any> = new Subject();
  sourcelist = GlobalService.SourceList;
  joblist : any
  filesizeExceeded  : boolean = false;
  resumeFile : any
  talentpoolslist : any
  noTalentpoolError : boolean = false;
  sourcelist_data : any
  talentvalue :any
  candidatenumber :any
  successMessage  : string
  errorMessage : string
  talentErrorMessage : any
  duplicatecandidateid : any
  duplicatecandidate : any
  talentpoolnumber : any
  talentpoolid : any
  incorrectFileFormat: boolean = false;
  specialCharaterError: boolean = false;
  @Input() talentpoolDetails: any;

  @Output() passEntry : EventEmitter<any> = new EventEmitter();


  constructor(private fb: UntypedFormBuilder , private searchtoolbox: SearchtoolboxService
    ,private modalService: NgbModal , private candidateservice : CandidateService ,
    private talentpoolservice : TalentpoolService ,private localstorageservice : LocalStorageService) { }

  ngOnInit() {
    this.create_candidate = this.fb.group({
      firstName: ['', Validators.compose([Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      lastName: ['', Validators.compose([Validators.required,noWhitespaceValidator,Validators.pattern(/^(?!.*<[^>]+>).*/i)])],
      companyName: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      jobName: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      worklocation: ['',Validators.pattern(/^(?!.*<[^>]+>).*/i)],
      publicProfileLink: ['', [Validators.required, Validators.pattern('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      source: ['', [Validators.required,noWhitespaceValidator]],
      talentpoolname:['']
    })

    if(this.talentpoolDetails) {
      this.talentpoolnumber = this.talentpoolDetails.talentpoolnumber
      this.create_candidate.patchValue({talentpoolname: this.talentpoolDetails.name});
      this.create_candidate.get('talentpoolname').disable();
    } else {
      this.create_candidate.get('talentpoolname').enable();
    }

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
  }
  }

  //For typeAhead Auto DropDown
  getautocompleteData(type,input): Observable<any> {
    let data ={
      "dropdowntype": type,
      "searchedstring": input
    }
    var subject = new Subject<any>();
    this.searchtoolbox.getAutoCompleteDataList(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        subject.next(res.data);
      }else{
        subject.next([])
      }
    })
    return subject.asObservable();
  }
  //Typeahead for CompanyName
  searchCompany() {
    this.create_candidate.controls['companyName'].valueChanges.subscribe((companyvalue: any) => {
      if (companyvalue != '' && companyvalue.length > 2 && this.autocomplete_company) {
        this.autocomplete_company = false
        this.getautocompleteData('companies',companyvalue).subscribe((res)=>{
          this.companylist  = res.map(value => value['company_name'])
          this.autocomplete_company = true
        })
      } else {
        this.companylist = []
      }
    })
  }

  //Typeahead for Location
  searchLocation() {
    this.create_candidate.controls['worklocation'].valueChanges.subscribe((locationvalue: any) => {
      if (locationvalue != '' && locationvalue.length > 2 ) {
        this.getautocompleteData('locations',locationvalue).subscribe((res)=>{
          this.locationlist  = res
        })
      } else {
        this.locationlist = []
      }
    })
  }

  //Typeahead for JobTitles
  searchJobs() {
    this.create_candidate.controls['jobName'].valueChanges.subscribe((jobvalue: any) => {
    if (jobvalue != '' && jobvalue.length > 2 ) {
        this.getautocompleteData('job titles',jobvalue).subscribe((res)=>{
          this.joblist  = res
        })
      } else {
        this.joblist = []
      }
    })
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  /**
   * Upload Resume File Name
   */
  uploadFileName = '';

  uploadFile(e){
    const resumeFile = e.target.files[0]
    this.uploadFileName = resumeFile.name;
    const sanitizedFile = GlobalService.validateAndSanitizeFile(resumeFile);
    this.incorrectFileFormat = false;
    this.specialCharaterError = false;
    this.filesizeExceeded = false;

    let validFileExtensions = ['doc', 'docx', 'pdf', 'txt'];
    let uploadedFileExtension = resumeFile.name.split('.').pop();

    if (!validFileExtensions.includes(uploadedFileExtension.toLowerCase())) {
      this.incorrectFileFormat = true;
    }
    // Verify file size (File size cannot exceed 5 MB)
    if(resumeFile.size > 5242880){
     this.filesizeExceeded = true
   }else{
     this.filesizeExceeded = false
   }
   if(!this.filesizeExceeded && !this.specialCharaterError && !this.incorrectFileFormat){
     this.filesizeExceeded = false
     this.candidateservice.uploadresume(sanitizedFile).subscribe((res:any)=>{
       if(res.status == 'success'){
         this.resumeFile = res;
         e.target.value = ''
       }
     })
   }
   }

  removeFile(){
    let data ={
     documenturlsarray : [this.resumeFile.docurl , this.resumeFile.previewurl]
    }
    this.candidateservice.removeuploadeddocuments(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.uploadFileName = '';
       this.resumeFile = null
      }
    })
  }

  getAllTalentpool(){
    this.talentpoolservice.getTalentpoolList(this.localstorageservice.getItem('usernumber')).subscribe((res: any) => {
      if (res.status == "success") {
        this.talentpoolslist = res.data.talentpools.filter((x) =>{ return x.name.toLowerCase().includes(this.create_candidate.value.talentpoolname.toLowerCase()) });
          let talentpoolFound =  this.talentpoolslist.find(x => (x.name == this.create_candidate.value.talentpoolname));
          if(talentpoolFound == undefined && this.create_candidate.value.talentpoolname != ''){
            this.noTalentpoolError = true
          }else{
            this.noTalentpoolError = false
          }
      }
    })
  }

  getSourceList(){
    this.sourcelist_data = this.sourcelist.filter((x) =>{ return x.toLowerCase().includes(this.create_candidate.value.source.toLowerCase()) });
  }

  SaveTalent() {
    if(this.talentvalue !=null){
    let data = {
      "candidatenumber": this.candidatenumber,
      "usernumber": this.localstorageservice.getItem('usernumber'),
      "pipelinestatus": this.talentvalue,
      "activitylog": [
        {
          "action": "'update'",
          "tablename": "'candidate'",
          "type": "'pipeline status'",
          "updatedfieldname": "'pipelinestatus'",
          "oldvalue": "'Cold'",
          "newvalue": "'" + this.talentvalue + "'"
        }
      ]
    }
    this.candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
      if (res.status == "success") {
        this.modalService.dismissAll();
        this.candidateservice.createCandidateData();
        this.successMessage = "Candidate Created Successfully"
        //const modalRef = this.modalService.open(this.successModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
      else {
        this.errorMessage = "Something Went Wrong"
        //const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
      }
    })}
    else{
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }

  openConfirmationModal(talentpool) {
    this.talentpoolnumber = talentpool.talentpoolnumber;
    this.talentpoolid = talentpool.talentpoolid;
  }

  createCandidate() {
    if (this.create_candidate.valid) {
      if(this.noTalentpoolError == false){

      let data = {
        firstname: this.create_candidate.value.firstName,
        middlename: '',
        lastname: this.create_candidate.value.lastName,
        companyname: this.create_candidate.value.companyName,
        jobtitle: this.create_candidate.value.jobName,
        locationname: this.create_candidate.value.worklocation,
        profileurl: this.create_candidate.value.publicProfileLink,
        source: this.create_candidate.value.source,
        usernumber : this.localstorageservice.getItem('usernumber')
      }
      this.candidateservice.checkduplicatecandidate(data).subscribe((res: any) => {
        if (res.status == 'success') {
          let duplicatecandidate = res.data.duplicatecandidate
          if (duplicatecandidate == true) {
            this.duplicatecandidateid = res.data.existingcandidatenumber
            this.passEntry.emit('duplicatecandidate')
          }
          else {
            let data = {
              firstname: this.create_candidate.value.firstName,
              middlename: '',
              lastname: this.create_candidate.value.lastName,
              companyname: this.create_candidate.value.companyName,
              jobtitle: this.create_candidate.value.jobName,
              locationname: this.create_candidate.value.worklocation,
              profileurl: this.create_candidate.value.publicProfileLink,
              source: this.create_candidate.value.source,
              usernumber : this.localstorageservice.getItem('usernumber')
            }
            this.candidateservice.createCandidate(data).subscribe((res: any) => {
              if (res.status == 'success') {
                this.create_candidate.reset()
                this.candidatenumber = res.data.createdcandidatenumber;
                if(res.data.createdcandidatenumber && this.talentpoolnumber ){
                  let talentpooldata = {
                    talentpoolnumber: this.talentpoolnumber,
                    insertobject: [{'candidatenumber' :  res.data.createdcandidatenumber}],
                    usernumber : this.localstorageservice.getItem('usernumber')
                  }
                  this.talentpoolservice.addCandidatetoTalentpool(talentpooldata).subscribe((res: any) => {
                    if (res.status == 'success') {
                     // this.createcandidate_form = false
                     this.passEntry.emit('candidatecreated')

                    }else {
                      this.errorMessage = "Something Went Wrong"
                      //const modalRef = this.modalService.open(this.errorModal, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
                      this.passEntry.emit('error')
                    }
                  })
                }else{
                  this.passEntry.emit('candidatecreated')
                }
              } else {
                this.passEntry.emit('error')

              }
            }, (err) => { }, ()=>{
             if(this.resumeFile){
               let data ={
                candidatenumber : this.candidatenumber,
                cvfilesarray:[{
                  filename : this.resumeFile.filename,
                  docurl : this.resumeFile.docurl,
                  previewurl : this.resumeFile.previewurl,
                  isactive : 1
                }],
                cvactivitylog :[{
                  "action": "'added'",
                  "type": "'CV'",
                  "oldvalue": "'" + this.resumeFile.filename + "'",
                }]
               }
               this.candidateservice.savecvfiles(data).subscribe((res:any)=>{
                 if(res.status == 'failure'){
                  this.passEntry.emit('errorinsavingfile')
                 }
               })
             }
            })
          }
        }
      })

    } else {
      this.noTalentpoolError = true
    }
    }

    else {
      this.validateAllFormFields(this.create_candidate);
    }
  }


  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }



}
